import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, NgForm, Validators } from '@angular/forms';
import { AuthService } from '../../../core/auth.service';
import { HELP_CLINIC_PROFILE } from '../../../shared/constants/help-buttons';
import { PopoverService } from '../../../shared/popover/popover.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

@Component({
    selector: 'symptoms-modal-component',
    templateUrl: './symptoms-modal.component.html',
    styleUrls: ['./symptoms-modal.component.scss'],
})
export class SymptomsModalComponent implements OnChanges {
    @Input() params: Object;
    @Input() formLoading: boolean;
    @Input() symptomsByDomain: Object[];
    @Input() form: FormGroup;
    @Input() formSubmitted: boolean;
    @Input() languages: Object[];
    @Input() item: Object[];
    @Input() itemLanguage: string;
    @Input() symptoms: Object[];
    @Input() domains: Object[];
    @Input() neutral_system_ids: Object[];
    @Input() standards: Object[];
    @Input() indicators: Object[];
    @Input() authService: AuthService;
    @Input() token: string;
    @Input() helpRawData = '';

    @Output() hideModal = new EventEmitter<any>();
    @Output() submit = new EventEmitter<any>();
    @Output() openFormModal = new EventEmitter<any>();
    @Output() activateConfirmationModal = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();
    @Output() switchLanguage = new EventEmitter<any>();

    genders = [
        {
            name: 'Not Applicable',
            value: 0
        },
        {
            name: 'Male',
            value: 1
        },
        {
            name: 'Female',
            value: 2
        }
    ];
    HELP_CLINIC_PROFILE = HELP_CLINIC_PROFILE;
    _symptomsByDomain: any;

    // options: [{ symptom_neutral_name_system_id: 'Mary' }, { symptom_neutral_name_system_id: 'Shelley' }, { symptom_neutral_name_system_id: 'Igor' }];
    filteredOptions: any;
    neutralSeleted: any;

    @ViewChild('formDirective') private formDirective: NgForm;

    constructor(
        public popoverService: PopoverService,
        public translate: TranslateService,
    ) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['params'] && this.formDirective) {
            this.formDirective.resetForm();
        }
        // set helpTemplates
        this.popoverService.setHelpContent(this.helpRawData);
    }

    onInputFocused(event, formGroup: any, isBottomField?: boolean) {
        let uagent = navigator.userAgent.toLowerCase();
        if (!(/safari/.test(uagent) && !/chrome/.test(uagent))) {
            // wait for the virtual keyboard to scroll up so that the scroll height can be updated correctly
            setTimeout(() => {
                if (isBottomField) {
                    document.body.scroll({
                        top: document.body.scrollHeight,
                        left: 0,
                        behavior: 'smooth'
                    });
                } else {
                    document.body.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }

                let modalEl = document.getElementsByClassName('modal')[0] as HTMLElement;
                modalEl.scroll({
                    top: formGroup.offsetTop,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 2000);
        }
    }

    toggleAcute($event, affectedElement: string) {
        if ($event.target.value === 1) {
            return true;
        }
        this.form.controls[affectedElement].setValue(1);
    }

    getSymptomsByDomain(domainId) {
        if (!domainId) {
            return false;
        }
        let symptoms = _.filter(this.symptoms, function (item) {
            return (item['domain_id'] == domainId);
        });
        this.symptomsByDomain = symptoms;
    }

    selectSymptom($event) {
        if (parseInt($event.value) !== 0) {
            const symptomId = $event.value;
            const selectedSymptom = _.find(this.symptoms, {symptom_system_id: symptomId});
            if (selectedSymptom) {
                this.languages.forEach(language => {
                    this.form.controls['symptom_name_' + language['locale']].setValue(selectedSymptom['symptom_name_' + language['locale']]);
                    this.form.controls['symptom_name_on_map_' + language['locale']].setValue(selectedSymptom['symptom_name_on_map_' + language['locale']]);
                });
            }
            if(selectedSymptom.symptom_neutral_name_system_id){
                this.form.controls.symptom_neutral_name_system_id.setValue(selectedSymptom.symptom_neutral_name_system_id);
                return this.autofillDataRelation(selectedSymptom.symptom_neutral_name_system_id);
            }
            return true;
        }
        this.languages.forEach(language => {
            this.form.controls['symptom_name_' + language['locale']].setValue('');
            this.form.controls['symptom_name_on_map_' + language['locale']].setValue('');
        });
    }

    generateModelToSubmit() {
        return this.submit.emit();
    }

    displayFn(neutralSystemId): string {
        return neutralSystemId || '';
    }

    private _filter(name: string) {
        const filterValue = name.toLowerCase();

        let data = this.neutral_system_ids.filter(
            option => option['symptom_neutral_name_system_id'].toString().includes(filterValue)
        );
        this.filteredOptions = _.map(data, 'symptom_neutral_name_system_id');
        return data;
    }

    getNeutralNames($event) {
        const value = $event.target.value || '';
        return value ? this._filter(value as string) : this.neutral_system_ids.slice();
    }

    autofillDataRelation(selectedItem){
        const data = this.neutral_system_ids.filter(
            option => option['symptom_neutral_name_system_id'].toString().includes(selectedItem)
        );
        if(!data[0]['symptom_svg_' + this.itemLanguage]){
            return false;
        }
        const neutralItem = JSON.parse(data[0]['symptom_svg_' + this.itemLanguage]);
        const neutralName = data[0]['symptom_neutral_name_' + this.itemLanguage];
        this.form.controls['coordinate_x_' + this.itemLanguage].setValue(neutralItem.x);
        this.form.controls['coordinate_y_' + this.itemLanguage].setValue(neutralItem.y);
        this.form.controls['text_placement_' + this.itemLanguage].setValue(neutralItem.text_placement);
        this.form.controls['symptom_neutral_name_' + this.itemLanguage].setValue(neutralName);
        this.languages.forEach(language => {
            if (language['locale'] != this.itemLanguage) {
                let dataDiff = data[0];
                this.form.controls['symptom_neutral_name_' + language['locale']].setValue(dataDiff['symptom_neutral_name_' + language['locale']]);
                this.form.controls['symptom_svg_' + language['locale']].setValue(dataDiff['symptom_svg_' + language['locale']]);
            }
        });
    }

    changeLanguage(value){
        this.itemLanguage = value;
        return this.switchLanguage.emit(value);
    }
}
